import { Share } from '@mui/icons-material';
import React, { useState, useMemo, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { shareTextOf, totalPrompts } from '../../utils/Universalfunctions';
import { categoryAll } from '../../Datas/categoryPosts';
import SEO from '../../config/SEO';



const Category = () => {


     const { id } = useParams();

     // 1. Memoize the base category object
     const category = useMemo(() => categoryAll?.[id], [id]);

     // 2. Fix the "list logical expression" warning by memoizing the list
     const list = useMemo(() => {
          return category?.categoryListAll || [];
     }, [category]);

     const [currentPage, setCurrentPage] = useState(1);
     const itemsPerPage = 6;

     // 3. This now has a stable 'list' dependency
     const filteredList = useMemo(() => {
          return list.filter(item => item?.show !== false);
     }, [list]);

     const totalItems = filteredList.length;
     const totalPages = Math.ceil(totalItems / itemsPerPage);


     const dynamicFaqs = useMemo(() => {
          const catFaqs = faqMap?.[id] || [];
          const merged = [...catFaqs, ...baseFaqs];
          return merged.slice(0, 6);
     }, [id]);

     // Current page ka data nikalna
     const currentData = useMemo(() => {
          const firstPageIndex = (currentPage - 1) * itemsPerPage;
          const lastPageIndex = firstPageIndex + itemsPerPage;
          return filteredList.slice(firstPageIndex, lastPageIndex);
     }, [currentPage, filteredList]);

     // Function to handle page change
     const handlePageChange = (pageNumber) => {
          setCurrentPage(pageNumber);
          window.scrollTo({ top: 0, behavior: 'smooth' });
     };


     const getPageNumbers = () => {
          const pages = [];

          if (totalPages <= 8) {
               // Agar 8 se kam pages hain to saare dikhao
               for (let i = 1; i <= totalPages; i++) pages.push(i);
          } else {
               // Hamesha pehla page dikhao
               pages.push(1);

               if (currentPage > 3) {
                    pages.push('...');
               }

               // Current page ke aas-paas ke numbers
               const start = Math.max(2, currentPage - 1);
               const end = Math.min(totalPages - 1, currentPage + 1);

               for (let i = start; i <= end; i++) {
                    pages.push(i);
               }

               if (currentPage < totalPages - 2) {
                    pages.push('...');
               }

               // Hamesha aakhri page dikhao
               pages.push(totalPages);
          }
          return pages;
     };


     useEffect(() => {
          if (totalPages && currentPage > totalPages) {
               setCurrentPage(1);
          }
     }, [totalPages, currentPage]);

     return (
          <>
               <SEO
                    title={category?.seo_title}
                    description={category?.seo_description}
                    keywords={category?.seo_keywords}
                    canonicalPath={category?.seo_canonicalPath}
               />

               
               <div className="cat-wrapper">
                    <div className="bg-noise"></div>

                    <section className="hero-section">
                         <div className="hero-main">
                              <div className="left-side">
                                   <span className="label"><b>🟢</b> {category?.modal}</span>
                                   <h1>{category?.name} Prompts.</h1>
                                   <p>{category?.paragraph}.</p>
                                   <div className="btn-group">
                                        <Link to="/gallery" className="main-btn">Browse Library</Link>
                                        <Link to="/marketplace" className="sub-btn"> Sell & Earn </Link>
                                   </div>
                              </div>
                              <div className="right-stats">
                                   <div className="stat-card">
                                        <span>{totalPrompts}+</span>
                                        <small> All Active Prompts</small>
                                   </div>
                                   <div className="stat-card">
                                        <span>{list?.length}+</span>
                                        <small>Top {category?.name} Category </small>
                                   </div>
                              </div>
                         </div>
                    </section>

                    <section className="content-grid">
                         <div className="header-flex">
                              <h2>Featured Assets</h2>
                              <div className="grid-controls">
                                   <span>Sort by: <b>Newest</b></span>
                              </div>
                         </div>

                         <div className="grid-layout">
                              {currentData.map((i, key) => (
                                   <div className="premium-card" key={key}>
                                        <div className="img-area">
                                             <Link to={i?.url} className='stretched-link'>
                                                  <img src={`https://res.cloudinary.com/dqwbmkrm8/image/upload/v1772471958/${i?.image}`} alt={i?.imageAlt} />
                                                  <div className="tag">OPEN</div>
                                             </Link>
                                        </div>
                                        <div className="details-area">
                                             <div className="top-row">
                                                  <span className="date">{i?.date}</span>
                                                  <button type='button' className="copy-icon" onClick={() => shareTextOf(`${window.location.origin}${i?.url}`)}> <Share />  </button>
                                             </div>
                                             <h3>{i?.title}</h3>
                                             <p>{i?.excerpt.slice(0, 200) + '....'}</p>
                                             <Link to={i?.url} className="link-arrow">Explore Full Prompt ↗</Link>
                                        </div>
                                   </div>
                              ))}
                         </div>
                    </section>

                    {/* --- DYNAMIC PAGINATION --- */}
                    {totalPages > 1 && (
                         <section className="pagination-wrapper">
                              <div className="pagination-container">
                                   <button
                                        className="nav-btn prev"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                   >
                                        <span>←</span> Previous
                                   </button>

                                   <div className="page-numbers">
                                        {getPageNumbers().map((pageNum, index) => (
                                             <button
                                                  key={index}
                                                  className={`num-btn ${currentPage === pageNum ? 'active' : ''} ${pageNum === '...' ? 'dots' : ''}`}
                                                  onClick={() => pageNum !== '...' && handlePageChange(pageNum)}
                                                  disabled={pageNum === '...'}
                                             >
                                                  {pageNum}
                                             </button>
                                        ))}
                                   </div>

                                   <button
                                        className="nav-btn next"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                   >
                                        Next <span>→</span>
                                   </button>
                              </div>
                              <p className="results-count">
                                   Showing {((currentPage - 1) * itemsPerPage) + 1} - {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} Category
                              </p>
                         </section>
                    )}

                    {/* FAQ & TAGS ... same as before */}
                    <section className="faq-modern">
                         <div className="faq-header">
                              <h2>FAQs <br /> About</h2>
                              <p>Everything you need to know about our prompt ecosystem.</p>
                         </div>
                         <div className="faq-items">
                              {dynamicFaqs?.map((item, i) => (
                                   <div className="faq-row" key={i}>
                                        <div className="q-wrap">
                                             <h4>{item?.q}</h4>
                                             <p>{item?.a}</p>
                                        </div>
                                   </div>
                              ))}
                         </div>
                    </section>

                    <section className="tags-section">
                         <h3>Trending {category?.name} Categories</h3>
                         <div className="tags-flow">
                              {list?.map((tag, idx) => (
                                   <Link to={`${tag?.url}`} key={idx} className="tag-pill">{tag?.nameOfList}</Link>
                              ))}
                         </div>
                    </section>


                    <section className='seo-content'> 
                         <div className='__container'>
                              <h1>{category?.seo_title}</h1>
                         <p className='mt-5'> {category?.seo_description}</p>
                         <code className='opacity-0 invisible'>{category?.seo_keywords}</code>
                         </div>
                    </section>
               </div>
          </>

     );
};

export default Category;

export const faqMap = {
     "google-gemini-prompts": [
          {
               q: "How do I write better prompts for Google Gemini?",
               a: "Use clear context, describe the scene or task in full sentences, and add details like style, tone, lighting, and output format to get more accurate Gemini AI results."
          },
          {
               q: "Does Gemini support negative prompts and aspect ratio?",
               a: "Yes—Gemini works best with natural language. Mention what you don’t want (e.g., no blur, no text) and specify the framing like wide cinematic 16:9 or vertical 9:16."
          },
          {
               q: "What’s the best prompt structure for Gemini image generation?",
               a: "A strong structure is: subject + environment + style + lighting + camera angle + quality. This helps Gemini understand composition and deliver better AI images."
          },
          {
               q: "How can I make Gemini outputs more realistic and high quality?",
               a: "Add realism signals like ‘photorealistic’, ‘natural skin texture’, ‘sharp focus’, ‘high detail’, and define lighting such as golden hour or soft studio light."
          },
          {
               q: "Can Gemini generate accurate text inside images?",
               a: "It has improved, but results vary. For best accuracy, keep text short, wrap it in quotes, and mention clean typography with high contrast."
          },
          {
               q: "How do I turn a simple idea into a powerful Gemini prompt?",
               a: "Start with your idea and ask Gemini to expand it into a detailed prompt with style references, cinematic lighting, and a clear output goal."
          }
     ],

     "chatgpt-prompts": [
          {
               q: "How do I write effective ChatGPT prompts for better answers?",
               a: "Give ChatGPT a role, your goal, key context, and the exact output format you want. This reduces generic replies and improves accuracy."
          },
          {
               q: "What is the best ChatGPT prompt format for content writing?",
               a: "Use: topic + audience + tone + length + SEO keywords + structure (headings, bullets). This helps generate SEO-friendly content that’s easy to publish."
          },
          {
               q: "How can I make ChatGPT produce more detailed responses?",
               a: "Ask for step-by-step reasoning, examples, and a checklist. You can also say: ‘ask me 3 questions before answering’ for better clarity."
          },
          {
               q: "Can ChatGPT improve my existing prompt or rewrite it professionally?",
               a: "Yes. Paste your prompt and request: ‘optimize this prompt for clarity, add missing details, and create 3 improved versions’."
          },
          {
               q: "How do I get ChatGPT to follow the exact format I need?",
               a: "Specify output rules like headings, tables, JSON, word limits, and ‘don’t add extra text’. Formatting instructions make outputs consistent."
          },
          {
               q: "What are the best use cases for ChatGPT prompts?",
               a: "Top use cases include SEO blog writing, marketing copy, code help, interview prep, business ideas, and productivity workflows."
          }
     ]
};

export const baseFaqs = [
     {
          q: "Why do prompts matter for AI results?",
          a: "Prompts guide the AI with context and constraints. Better prompts produce more accurate, creative, and consistent outputs."
     },
     {
          q: "How often should I update my prompts?",
          a: "Update prompts whenever your goal changes or if the AI output becomes inconsistent. Small improvements in clarity can boost results quickly."
     }
];